/**
 * Table row for a bulk RMA action chunk / job ledger entry.
 */
import DateTimeV2, { DATETIME_VIEW } from '../../../../../../components/datetime-v2/datetime-v2';
import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../../components/fonts/font-props';
import TableRow from '../../../../../../components/table/components/table-row/table-row';
import { Tooltip, TOOLTIP_VARIANTS } from '../../../../../../components/tooltip/tooltip';
import { TOOLTIP_PLACEMENTS } from '../../../../../../components/tooltip/tooltip-box';
import { useDateTimeFormattingParams } from '../../../../../../hooks/use-datetime-formatting-params';
import { IBulkRmaActionJob } from '../../../../../../services/api/troubleshooting-service';
import { JOB_STATUS_LABELS } from '../../utils/bulk-rma-action-labels';
import BulkRmaStatusChip from '../bulk-rma-status-chip/bulk-rma-status-chip';

interface IChunkLedgerTableRowProps {
    job: IBulkRmaActionJob;
}

const ChunkLedgerTableRow: React.FC<IChunkLedgerTableRowProps> = ({ job }) => {
    const dateTimeParams = useDateTimeFormattingParams();
    const failureReason = job.failure_reason ?? '—';

    const cells = [
        <FontBody2>#{job.id}</FontBody2>,
        <BulkRmaStatusChip
            status={job.status}
            label={JOB_STATUS_LABELS[job.status] ?? job.status}
        />,
        <FontBody2>{job.rma_count ?? '—'}</FontBody2>,
        <FontBody2>
            <DateTimeV2
                {...dateTimeParams}
                utcDateString={job.dispatched_at ?? ''}
                dateTimeView={DATETIME_VIEW.FULL}
            />
        </FontBody2>,
        <FontBody2>
            <DateTimeV2
                {...dateTimeParams}
                utcDateString={job.started_at ?? ''}
                dateTimeView={DATETIME_VIEW.FULL}
            />
        </FontBody2>,
        <FontBody2>
            <DateTimeV2
                {...dateTimeParams}
                utcDateString={job.finished_at ?? ''}
                dateTimeView={DATETIME_VIEW.FULL}
            />
        </FontBody2>,
        <Tooltip
            content={
                job.failure_reason
                    ? (
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            {job.failure_reason}
                        </FontBody2>
                    )
                    : null
            }
            placement={TOOLTIP_PLACEMENTS.LEFT}
            variant={TOOLTIP_VARIANTS.INFO}
        >
            <span className="bulk-rma-actions-page__ellipsis">
                <FontBody2>{failureReason}</FontBody2>
            </span>
        </Tooltip>,
    ];

    return (
        <TableRow
            name={`bulk-job-${job.id}`}
            skipWrapingCell
            cells={cells}
        />
    );
};

export default ChunkLedgerTableRow;
